export default {

  getMessageSide(isSender) {
    return isSender ? 'right' : 'left'
  },

  isFullUrl(url) {
    return /^https?:\/\//i.test(url)
  },

  // les visuels de commandes (commands/water.gif) gardent leur extension ; un id nu reste un jpg
  ensureJpgExtension(name) {
    return /\.(jpe?g|gif|png|webp)$/i.test(name) ? name : `${name}.jpg`
  },

}
